/**
 * Parse CSV text into rows. Commas/semicolons/tabs split fields only outside double quotes.
 * Supports escaped quotes ("") inside quoted fields and newlines inside quoted fields.
 */
export function parseCSVRows(text) {
    if (text == null || text === '') return [];
    const normalized = String(text)
        .replace(/^\uFEFF/, '')
        .replace(/\r\n/g, '\n')
        .replace(/\r/g, '\n');

    const rows = [];
    let row = [];
    let field = '';
    let inQuotes = false;
    let i = 0;

    while (i < normalized.length) {
        const c = normalized[i];

        if (inQuotes) {
            if (c === '"' && normalized[i + 1] === '"') {
                field += '"';
                i += 2;
                continue;
            }
            if (c === '"') {
                inQuotes = false;
                i++;
                continue;
            }
            field += c;
            i++;
            continue;
        }

        if (c === '"') {
            inQuotes = true;
            i++;
            continue;
        }

        if (c === ',' || c === ';' || c === '\t') {
            row.push(field.trim());
            field = '';
            i++;
            continue;
        }

        if (c === '\n') {
            row.push(field.trim());
            if (row.some((cell) => cell.length > 0)) rows.push(row);
            row = [];
            field = '';
            i++;
            continue;
        }

        field += c;
        i++;
    }

    row.push(field.trim());
    if (row.some((cell) => cell.length > 0)) rows.push(row);

    return rows;
}
